import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  viewChildren,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { LegacyIcon } from '@legacy/constants';
import { ModuleIconComponent } from '@shared/components/module-icon/module-icon.component';

@Component({
  selector: 'itv-module-icon-list',
  templateUrl: './module-icon-list.component.html',
  styleUrls: ['./module-icon-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ModuleIconComponent, TranslateModule],
})
export class ModuleIconListComponent {
  @Input() icons: LegacyIcon[];
  @Input() selected: number;
   
  @Output('selectedchange') selectedChange = new EventEmitter<number>();

  private readonly options = viewChildren<ElementRef<HTMLElement>>('iconOption');

  get allIcons(): LegacyIcon[] {
    return this.icons.filter(i => !!i.name);
  }

  iconClick(id: number) {
    this.selected = id;
    this.selectedChange.emit(id);
  }

  // Radiogroup keyboard support (WCAG 2.1.1): Left/Right arrows move focus and select
  // (focus follows selection — no separate Enter/Space needed).
  onKeydown(event: KeyboardEvent, index: number) {
    const icons = this.allIcons;
    if (!icons.length) return;
    let next: number;
    switch (event.key) {
      case 'ArrowRight':
        next = (index + 1) % icons.length;
        break;
      case 'ArrowLeft':
        next = (index - 1 + icons.length) % icons.length;
        break;
      default:
        return;
    }
    event.preventDefault();
    this.iconClick(icons[next].key);
    this.options()[next]?.nativeElement.focus();
  }
}
